import { useCallback } from 'react';

interface UseTimeInputParams {
  timeInputValue: string | null;
  setTimeInputValue: (value: string | null) => void;
  formatTime: (time: number) => string;
  currentTime: number;
  handleTimeInputSubmitFromHook: (value: string | null) => string | undefined;
}

export const useTimeInput = ({
  timeInputValue,
  setTimeInputValue,
  formatTime,
  currentTime,
  handleTimeInputSubmitFromHook,
}: UseTimeInputParams) => {
  const handleTimeInputChange = useCallback(
    (value: string) => {
      setTimeInputValue(value);
    },
    [setTimeInputValue],
  );

  const handleTimeInputFocus = useCallback(() => {
    setTimeInputValue(formatTime(currentTime).replace('-', ''));
  }, [formatTime, currentTime, setTimeInputValue]);

  const handleTimeInputBlur = useCallback(() => {
    setTimeInputValue(null);
  }, [setTimeInputValue]);

  const handleTimeInputSubmit = useCallback(() => {
    const newValue = handleTimeInputSubmitFromHook(timeInputValue);
    if (newValue !== undefined) {
      setTimeInputValue(newValue);
    }
  }, [timeInputValue, handleTimeInputSubmitFromHook, setTimeInputValue]);

  return {
    handleTimeInputChange,
    handleTimeInputFocus,
    handleTimeInputBlur,
    handleTimeInputSubmit,
  };
};
